export default "__VITE_ASSET__DTw6pQ1f__"